import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './PodcastCard.module.scss'
import Player from '../player/Player'

function PodcastCard({ className, title, image, audio, date }) {
  return (
    <div className={classNames(styles.card, className)}>
      <div className={styles.imgWrapp}>
        <GatsbyImage image={image} alt="Crypto curious podcast" />
      </div>
      <div className={styles.contentWrapp}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.flex} />
        <div className={styles.player}>
          <Player {...{ audio }} date={date} />
        </div>
      </div>
    </div>
  )
}

PodcastCard.propTypes = {
  image: PropTypes.object,
  audio: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
}

export default PodcastCard
